import Head from 'next/head';

import {HeadSEO} from '@udemy/head-seo';

import {useSetupNavigation} from 'src/hooks/use-setup-navigation';
import {useCanonicalUrl} from 'src/hooks/useCanonicalUrl';
import {PageProps} from 'src/types/page-props';

import {META_DEFAULT_BASE_URL} from '../../lib/constants';
import {VoucherData, VoucherLandingPage} from './voucher-landing-page.react-component';

export type VoucherLandingPageFeatureProps = PageProps & {
    voucherData: VoucherData;
    // Next's own post-rewrite path from getServerSideProps's context.resolvedUrl. router.asPath
    // isn't reliable for this page's canonical url -- see useCanonicalUrl's resolvedPath param.
    resolvedUrl: string;
};

export const VoucherLandingPageFeature: React.FC<VoucherLandingPageFeatureProps> = (props) => {
    const {url: canonicalUrl} = useCanonicalUrl(
        [],
        META_DEFAULT_BASE_URL,
        undefined,
        props.resolvedUrl,
    );
    useSetupNavigation();

    const metaProps = {
        title: props.voucherData.exam.seoTitle,
        description: props.voucherData.exam.seoDescription,
    };

    return (
        <>
            <HeadSEO
                title={metaProps.title ?? ''}
                ogTitle={metaProps.title ?? ''}
                description={metaProps.description ?? ''}
                ogDescription={metaProps.description ?? ''}
                ogLocale={process.env.I18N_PATH_TO_BUNDLE_MAP[props.locale]}
                canonicalUrl={canonicalUrl}
                assetPath={process.env.ASSET_PREFIX}
                headWrapper={Head}
            />
            <VoucherLandingPage voucherData={props.voucherData} />
        </>
    );
};
